const state = {
    unreadIds: []
}

const getters = {
    unreadNetworkingMessagesIds: state => state.unreadIds,
    unreadNetworkingCountFrom: state => senderId => state.unreadIds.filter(msg => msg.sender_id == senderId).length
}

const mutations = {
    setUnreadNetworkingMessagesIds: (state, unreadIds) => {
        state.unreadIds = unreadIds
    },

    addNetworkingMessage: (state, message) => {
        if (state.unreadIds.some(msg => msg.id == message.id)) return
        state.unreadIds.push({
            id: message.id,
            sender_id: message.sender_id
        })
    },

    removeNetworkingMessage: (state, message) => {
        state.unreadIds = state.unreadIds.filter(msg => {
            return msg.id != message.id
        })
    },

    // read elsewhere (another device of the visitor)
    removeNetworkingMessagesByIds: (state, ids) => {
        state.unreadIds = state.unreadIds.filter(msg => !ids.includes(Number(msg.id)))
    }
}

const actions = {
    fetchNetworkingNotifications: ({ commit, dispatch }) => {
        axios.get('/networking/notifications')
                .then(response => {
                    let unreadIds = response.data.unreadIds

                    commit('setUnreadNetworkingMessagesIds', unreadIds)
                })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}